__turbopack_context__.v({
  "formPanelGroupWrapper": "panelGroup-module-scss-module__FkH70q__formPanelGroupWrapper",
  "panelGroup": "panelGroup-module-scss-module__FkH70q__panelGroup",
  "panelGroupContent": "panelGroup-module-scss-module__FkH70q__panelGroupContent",
  "panelGroupContentActive": "panelGroup-module-scss-module__FkH70q__panelGroupContentActive",
  "panelGroupHeader": "panelGroup-module-scss-module__FkH70q__panelGroupHeader",
  "panelGroupHeaderActive": "panelGroup-module-scss-module__FkH70q__panelGroupHeaderActive",
  "panelGroupHeaderArrow": "panelGroup-module-scss-module__FkH70q__panelGroupHeaderArrow",
  "panelGroupHeaderArrowIcon": "panelGroup-module-scss-module__FkH70q__panelGroupHeaderArrowIcon",
  "panelGroupHeaderArrowText": "panelGroup-module-scss-module__FkH70q__panelGroupHeaderArrowText",
  "panelGroupItem": "panelGroup-module-scss-module__FkH70q__panelGroupItem",
  "panelGroupWrapper": "panelGroup-module-scss-module__FkH70q__panelGroupWrapper",
  "panelWithHoverOnHeader": "panelGroup-module-scss-module__FkH70q__panelWithHoverOnHeader",
  "panelWithTable": "panelGroup-module-scss-module__FkH70q__panelWithTable",
});
